<template>
  <img
    :src="suitImage.src"
    class="card-img"
    :class="styleNotFound()"
    @click="showQuiz()"
    >
</template>

<script>
export default {
  props: {
    suit: {
      type: Object
    },

    suitImage: {
      type: Object
    }
  },

  methods: {
    styleNotFound: function () {
      if (!this.suit[this.suitImage.name]) {
        return { 'card-not-found': true }
      }
      return {}
    },

    showQuiz: async function () {
      const name = this.suitImage.name
      if (!this.suit[name]) {
        return
      }
      this.$store.commit('quiz/setQuiz', this.suit[name])
      await this.$store.dispatch('quiz/fetchHints', this.suit[name])
      this.$store.dispatch('popupQuiz/show', 'info')
    }
  }
}
</script>

<style lang="scss" scoped>
@import './_style.scss';
.card {
  &-img {
    width: 100%;

    &:hover {
      cursor: pointer;
    }
  }

  &-not-found {
    opacity: 0.2;
    &:hover {
      cursor: default;
    }
  }
}
</style>

